/**
 * Beta / dev-server configuration.
 * Targets the app2026 dev environment (app2026-ui / app2026-api hosts).
 * Built with: npm run build -- --configuration=staging
 */
export const environment = {
  production: false,
  apiUrl: 'https://app2026-api.simplifiedls.com/api/v1',
  appName: 'Simplified Lending Solutions (Beta)',
  tokenStorageKey: 'sls.auth.token',
  userStorageKey: 'sls.auth.user',
  // SLS-1180 Dashboards API is live; flip to true only for offline FE dev.
  useDashboardMock: false,
  // Client branding via GET /layout (site_layouts). Off until the API ships the endpoint.
  useLayoutApi: false,
};
